import cjsModule from './lib/index.js';

const {
  convertTranslationsFromLocPlatform,
  dateTimeFormat,
  getCalendarInfo,
  getTranslation,
  numberFormat,
  relativeTime,
  supportsIntl,
} = cjsModule;

export {
  convertTranslationsFromLocPlatform,
  dateTimeFormat,
  getCalendarInfo,
  getTranslation,
  numberFormat,
  relativeTime,
  supportsIntl,
};
export default cjsModule;
